module.exports = __webpack_public_path__ + "static/img/logo.f6a2636b.aef91e4a.png";